import React, { useState, useEffect } from "react";

const FlightForm = ({ tripId, onFlightAdded, onClose, existingData = null }) => {
  const [flight, setFlight] = useState(existingData || {});
  const [currency, setCurrency] = useState(existingData?.cost_currency || "GBP");
  const [currencySymbol, setCurrencySymbol] = useState(existingData?.cost_currency_symbol || "£");
  const [currencies, setCurrencies] = useState([]); 
  
	useEffect(() => {
	  const fetchCurrencies = async () => {
		try {
			// eslint-disable-next-line no-unused-vars
		  const token = localStorage.getItem("token");
		  const response = await fetch(`${process.env.REACT_APP_API_URL}/countries/countries/`);
		  if (response.ok) {
			const data = await response.json();
			//console.log("Fetched countries: ", data);

			const uniqueCurrencies = [];
			const seenCodes = new Set();

			for (const c of data) {
			  if (c.code && !seenCodes.has(c.code)) {
				seenCodes.add(c.code);
				uniqueCurrencies.push(c);
			  }
			}

			const priorityCodes = ["GBP", "EUR", "USD", "TWD", "JPY", "HKD"];

			const prioritized = uniqueCurrencies.filter(c => priorityCodes.includes(c.code));
			const others = uniqueCurrencies
			  .filter(c => !priorityCodes.includes(c.code))
			  .sort((a, b) => a.code.localeCompare(b.code));

			setCurrencies([...prioritized, ...others]);
		  } else {
			console.error("Failed to fetch currencies");
		  }
		} catch (error) {
		  console.error("Error fetching currencies", error);
		}
	  };

	  fetchCurrencies();
	  // eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);  

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFlight(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const method = existingData ? 'PUT' : 'POST';
    const url = existingData
      ? `${process.env.REACT_APP_API_URL}/subtripitems/flight/${existingData.id}`
      : `${process.env.REACT_APP_API_URL}/subtripitems/trip/${tripId}/flights`;

    const response = await fetch(url, {
      method,
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        ...flight,
        cost_currency: currency,
        cost_currency_symbol: currencySymbol,
      }),
    });

    if (response.ok) {
      onFlightAdded();
    } else {
      console.error("Failed to save flight");
    }
  };
 
  return (
    <div className="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center z-50 px-2">
      <div className="bg-white rounded-lg p-4 sm:p-6 shadow-lg w-full max-w-md overflow-y-auto max-h-[90vh]">
        <h2 className="text-lg sm:text-xl font-bold mb-4 text-center sm:text-left">{existingData ? "Edit Flight" : "Add Flight"}</h2>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
            <input type="text" name="flight_number" placeholder="Flight Number" value={flight.flight_number || ""} onChange={handleChange} className="border p-2 rounded" />
            <input type="text" name="confirmation_number" placeholder="Confirmation Number" value={flight.confirmation_number || ""} onChange={handleChange} className="border p-2 rounded" />
            <input type="text" name="depart_airport" placeholder="Depart Airport" value={flight.depart_airport || ""} onChange={handleChange} className="border p-2 rounded" />
            <input type="text" name="depart_airport_code" placeholder="Depart Airport Code" value={flight.depart_airport_code || ""} onChange={handleChange} className="border p-2 rounded" />
            <input type="text" name="arrive_airport" placeholder="Arrive Airport" value={flight.arrive_airport || ""} onChange={handleChange} className="border p-2 rounded" />
            <input type="text" name="arrive_airport_code" placeholder="Arrive Airport Code" value={flight.arrive_airport_code || ""} onChange={handleChange} className="border p-2 rounded" />
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
            <label className="text-sm">Departure Date</label>
            <label className="text-sm">Arrival Date</label>
            <input type="datetime-local" name="depart_date" value={flight.depart_date || ""} onChange={handleChange} className="border p-2 rounded" />
            <input type="datetime-local" name="arrive_date" value={flight.arrive_date || ""} onChange={handleChange} className="border p-2 rounded" />
          </div>

          <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-3">
            <select
              value={currency}
              onChange={(e) => {
                const selected = currencies.find(c => c.code === e.target.value);
                setCurrency(selected.code);
                setCurrencySymbol(selected.symbol);
              }}
              className="border p-2 rounded"
            >
              {currencies.map((c) => (
                <option key={c.code} value={c.code}>
                  {c.code} ({c.symbol})
                </option>
              ))}
            </select>
            <input type="number" step="0.01" name="cost" placeholder="Estimated cost" value={flight.cost || ""} onChange={handleChange} className="border p-2 rounded flex-1" />
          </div>

          <input type="text" name="attachment" placeholder="Attachment URL or text" value={flight.attachment || ""} onChange={handleChange} className="w-full border p-2 rounded" />
          <textarea name="notes" placeholder="Notes" value={flight.notes || ""} onChange={handleChange} className="w-full border p-2 rounded" />

          <div className="flex flex-col sm:flex-row justify-end gap-2">
            <button type="button" onClick={onClose} className="btn-full bg-gray-300 px-4 py-2 rounded">Cancel</button>
            <button type="submit" className="btn-full bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700">
              Save
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default FlightForm;